import { type HttpErrorData } from '@/libs/logger/types/logger-types';

export default function sendHttpError(httpErrorData: HttpErrorData) {
  fetch(`${process.env.NEXT_PUBLIC_APP_URL}/react18/api/logger/http-error`, {
    body: JSON.stringify(httpErrorData),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }).catch(() => null);
}
